export default "__VITE_ASSET__BiyXDHK3__"